"use client";

import { Typography } from "@aph/ui-lib-humanx";
import React from "react";
import styles from "./ArticleContent.module.scss";

interface ArticleContentProps {
  id?: string;
  articleLabel?: string;
  title?: string;
  subTitle?: string;
  className?: string;
  publisherName?: string;
  setSectionRef?: any;
}

const ArticleContent: React.FC<ArticleContentProps> = (props) => {
  const { id, title, subTitle, articleLabel, className = "", setSectionRef } = props;

  return (
    <div className={`${styles.articleRoot} ${className}`}>
      <div
        className={styles.topSection}
        id={`table-item-${id}`}
        ref={setSectionRef ? setSectionRef(`table-item-${id}`) : null}
      >
        <label className={styles.label}>{articleLabel}</label>
        {title && (
          <Typography component="h2" className={styles.title}>
            <div dangerouslySetInnerHTML={{ __html: title }} />
          </Typography>
        )}
        {subTitle && <div dangerouslySetInnerHTML={{ __html: subTitle }} className={styles.subTitle} />}
      </div>
    </div>
  );
};

export default ArticleContent;
